import React, { useState, useEffect, useReducer, useRef } from 'react';
import cx from 'classnames';
import { Flex, Modal } from 'antd-mobile';

import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import styles from './index.modules.less';
const ctx = document.querySelector('#showPopup');
/**
  - 使用方式：
  `globalThis.ShowPopupModal({
      popupView: () => {
        return (
          <div>
            <p>这是一个弹窗</p>
            <p>点击确认或取消按钮关闭弹窗</p>
          </div>
        )},
  });`
**/
export const ShowPopupModal = (props) => {
  const { popupView, visible, close, showCloseBtn, mode, ...rest } = props || {};
  const ContentView = () => {
    const setShowStatus = () => {
      cancelFun();
    };
    useEffect(() => {
      // 组件加载时，默认显示弹窗
      // setShowStatus(!!visible);
    }, [visible]);
    const cancelFun = () => {
      ReactDOM.render('', ctx);
    };
    const closest = (el, selector) => {
      const matchesSelector =
        el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
      while (el) {
        if (matchesSelector.call(el, selector)) {
          return el;
        }
        el = el.parentElement;
      }
      return null;
    };
    const onWrapTouchStart = (e) => {
      // fix touch to scroll background page on iOS
      if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
        return;
      }
      const pNode = closest(e.target, '.am-modal-content');
      if (!pNode) {
        e.preventDefault();
      }
    };
    if (mode == 'element') {
      if (!showStatus) return null;
      return (
        <Flex align="center" justify="center" style={{ width: '100%', height: '100%' }}>
          {popupView(cancelFun)}
        </Flex>
      );
    }
    return (
      <Modal
        visible={true}
        transparent
        className={styles.OutView}
        animationType="slide"
        maskClosable={true}
        onClose={setShowStatus}
        wrapProps={{ onTouchStart: onWrapTouchStart }}
        {...rest}>
        {popupView(cancelFun)}
        <Flex className={styles.tip} justify="center">
          长按图片可保存图片或分享好友
        </Flex>
        <span
          className={(styles.iconfont, styles['icon-close2'])}
          onClick={() => setShowStatus(false)}
        />
        {showCloseBtn && (
          <Flex className={styles.closeBtn} onClick={() => setShowStatus(false)}>
            关闭
          </Flex>
        )}
      </Modal>
    );
  };
  ReactDOM.render(<ContentView />, ctx);
};

ShowPopupModal.propTypes = {
  /**
   * 是否展示
   */
  visible: PropTypes.bool,
  /**
   * 关闭弹窗
   */
  showCloseBtn: PropTypes.bool,
  /**
   * 展示模式
   */
  mode: PropTypes.oneOf([
    'modal', // 弹框模式
    'element' // 元素模式
  ]),
  /**
   * 展示内容
   */
  popupView: PropTypes.func
};
ShowPopupModal.defaultProps = {
  visible: false,
  close: () => {
    // Modal.operation().close()
  },
  popupView: () => {
    return <div style={{ width: '300px', height: '200px', backgroundColor: '#fff' }}></div>;
  },
  showCloseBtn: false,
  mode: 'modal'
};



// WEBPACK FOOTER //
// ./src/components/PopupModal/index.js